import type { ILoginResponse } from "../models/loginResponse";
import type { TLoginResult } from "../types";

const mapLoginResponseToResult = ({
  userType,
  token,
  refreshToken,
  sessionId,
  contractedUrl,
  isPasswordExpired,
  hasInvalidDefaultAddresses,
  email,
  isNewUser,
  phone
}: ILoginResponse): TLoginResult | null => {
  if (userType === "contracted") {
    if (!sessionId || !contractedUrl) {
      return null;
    }
    return {
      isSuccess: true,
      notVerifiedFlag: false,
      contractedUser: { sessionId, redirectUrl: contractedUrl },
    };
  }

  if (!token || !refreshToken) {
    return null;
  }
  return {
    isSuccess: true,
    notVerifiedFlag: false,
    isNewUser: isNewUser ?? undefined,
    authData: { token, refreshToken, isPasswordExpired, hasInvalidDefaultAddresses, email, phone },
  };
};
export default mapLoginResponseToResult;
